import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form, Formik } from "formik";
import FormInputText from "src/components/Forms/FormInputText";
import { useTranslation } from "react-i18next";
import axios from "src/config/axios";

const OnlineReservationCheckinDialog = ({
  stayId,
  handleClose,
  handleSubmit,
}) => {
  const formRef = useRef();
  const { t } = useTranslation("dashboard");

  function submit(values, helpers) {
    helpers.setSubmitting(true);

    axios
      .post(`/api/v1/stays/${stayId}/redeem_code.json`, {
        nfc_card_uid: values.nfc_card_uid,
      })
      .then(() => {
        handleSubmit();
      })
      .catch((e) => {
        if (e.response.data) {
          helpers.setErrors(e.response.data);
        }
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  }

  return (
    <Modal onHide={handleClose} show={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("booking_details.online_reservation_checkin_dialog.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Formik
          innerRef={formRef}
          initialValues={{ nfc_card_uid: "" }}
          enableReinitialize={true}
          onSubmit={submit}
        >
          <Form autoComplete="false">
            <p>
              {t(
                "booking_details.online_reservation_checkin_dialog.description"
              )}
            </p>
            <FormInputText
              name={"nfc_card_uid"}
              label={t(
                "booking_details.online_reservation_checkin_dialog.nfc_card_uid.label"
              )}
            />
          </Form>
        </Formik>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {t("common:components.button.close")}
        </Button>

        <Button onClick={() => formRef.current.handleSubmit()}>
          {t("common:components.button.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default OnlineReservationCheckinDialog;
